import { HttpClient } from 'core/common/services';
import { NatalChart, UserNatalChartPayload } from '../../entities';
import { NatalChartServiceInterface } from '../../interfaces';
import { NatalChartMapper } from '../../mappers';
import { NatalChartDto } from './dto';

export class NatalChartService implements NatalChartServiceInterface {
  constructor(private readonly httpClient: HttpClient) {}

  async createNatalChart(payload: UserNatalChartPayload): Promise<NatalChart> {
    const mapper = new NatalChartMapper();

    const { data } = await this.httpClient.get<NatalChartDto>(`/natal-chart`, {
      params: payload,
    });

    return mapper.toEntity(data);
  }

  async createNatalChartPublic(payload: UserNatalChartPayload): Promise<NatalChart> {
    const mapper = new NatalChartMapper();

    const { data } = await this.httpClient.get<NatalChartDto>(`/natal-chart/public`, {
      params: payload,
    });

    return mapper.toEntity(data);
  }
}
